import { render, staticRenderFns } from "./SupplierChatsPage.vue?vue&type=template&id=64d6726f&scoped=true&lang=pug&"
import script from "./SupplierChatsPage.vue?vue&type=script&lang=js&"
export * from "./SupplierChatsPage.vue?vue&type=script&lang=js&"
import style0 from "./SupplierChatsPage.vue?vue&type=style&index=0&id=64d6726f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d6726f",
  null
  
)

export default component.exports